import { bgTypes } from 'styles/generateBgStyleByType';
import { system100, white, black } from 'Mui/styles/color';

/**
 * 好禮自由選設計 - 主視覺
 * isShowKeyVision: boolean 顯示主視覺
 * isUseCustomKeyVision: boolean 使用主視覺圖片網址
 * bgType: 主視覺背景類型 ( 1 : 顏色 / 2 : 圖片 / 3 : 文字＋背景  )
 * customImgUrl: 自訂背景圖片 url (電腦)
 * customMobileImgUrl 自訂背景圖片 url (手機)
 **/

export const defaultKeyVisionConfig = {
    isShowKeyVision: true,
    isUseCustomKeyVision: false,
    bgType: bgTypes.FROALA,
    customImgUrl: 'https://assets.fevercdn.com/promotion/img/PickThePrize_Keyvisual_Template.jpg',
    customMobileImgUrl:
        'https://assets.fevercdn.com/promotion/img/PickThePrize_Keyvisual_Template.jpg'
};

/**
 * 好禮自由選設計 - 獎品樣式
 * type: "image"(純圖片), "text"(純文字), "both"(圖片 & 文字)
 * isShowCaption: boolean 顯示獎品說明
 * colorText: string 文字顏色
 * colorBg: string 背景顏色
 **/
export const DISPLAY_IMAGE_TEXT = 'both';
export const DISPLAY_TEXT = 'text';
export const DISPLAY_IMAGE = 'image';
export const defaultPrizeCardStyleConfig = {
    type: DISPLAY_IMAGE_TEXT,
    isShowCaption: true,
    colorText: black.color,
    colorBg: white.color
};

export const CARD_GAP_SIZE = 8;

/**
 * 好禮自由選設計 - 獎品順序
 * prizesOrder: Prize[]
 **/
export const defaultPrizeOrderConfig = {
    prizesOrder: []
};

/**
 * 好禮自由選設計 - 排列方式
 * desktop: x1, x2, x3, x4
 * mobile: x1, x2
 **/
export const defaultPrizeCardLayoutConfig = {
    desktop: 4,
    mobile: 2
};

/**
 * 好禮自由選設計 - 領取取品按鈕
 * color: string 按鈕文字顏色
 * colorBg: string 按鈕背景顏色
 * isUseCustomImg: boolean 自訂樣式
 * customImgUrl: string 按鈕圖片
 **/
export const defaultActionButtonConfig = {
    color: white.color,
    colorBg: black.color,
    isUseCustomImg: false,
    customImgUrl: ''
};

/**
 * 好禮自由選設計 - 背景
 * colorBg: string 背景顏色
 * isUseCustomImg: boolean 自訂樣式
 * customImgUrl: string 背景圖片
 **/
export const defaultBgStyleConfig = {
    colorBg: system100.color,
    isUseCustomImg: false,
    customImgUrl: ''
};

export const defaultAnimationSetting = {
    keyVision: defaultKeyVisionConfig,
    prizeCardLayout: defaultPrizeCardStyleConfig,
    prizeCardOrder: defaultPrizeOrderConfig,
    prizeCardStyle: defaultPrizeCardLayoutConfig,
    button: defaultActionButtonConfig,
    BackgroundStyle: defaultBgStyleConfig
};
